import { scoreTown, computeScore } from "./scoring.js";

// Variëer elke slider random ±range (default 2), simuleer N keer,
// kijk hoe vaak elke town in de top-N (default 5) staat.
//
// Returns Map<townName, {topRate, avgRank, label, color}>
export function simulateRobustness(towns, baseWeights, concelhoBySlug, enforceVeto, opts = {}) {
  const {
    iterations = 60,
    range = 2,
    topN = 5,
  } = opts;
  if (!towns || towns.length === 0) return new Map();

  const counts = new Map();
  const rankSums = new Map();
  for (const t of towns) {
    counts.set(t.name, 0);
    rankSums.set(t.name, 0);
  }

  for (let it = 0; it < iterations; it++) {
    // Genereer variant van weights
    const w = {};
    for (const [k, v] of Object.entries(baseWeights)) {
      const delta = Math.round((Math.random() * 2 - 1) * range);
      w[k] = Math.max(0, Math.min(10, v + delta));
    }
    // Score alle towns met deze variant
    const scored = towns.map(t => {
      const c = concelhoBySlug[t.concelho];
      const s = scoreTown(t, w, c, enforceVeto);
      return { name: t.name, pct: s.pct, excluded: s.excluded };
    });
    scored.sort((a, b) => {
      if (a.excluded !== b.excluded) return a.excluded ? 1 : -1;
      return b.pct - a.pct;
    });
    // Tel hoe vaak elke town in de top-N staat
    for (let i = 0; i < scored.length; i++) {
      if (i < topN && !scored[i].excluded) {
        counts.set(scored[i].name, counts.get(scored[i].name) + 1);
      }
      rankSums.set(scored[i].name, rankSums.get(scored[i].name) + i + 1);
    }
  }

  const result = new Map();
  for (const t of towns) {
    const c = counts.get(t.name);
    const rate = c / iterations;
    const avgRank = rankSums.get(t.name) / iterations;
    let label = "—", color = "#8e98a3";
    if (rate >= 0.70) { label = "stabiel";   color = "#3d6e48"; }
    else if (rate >= 0.30) { label = "wisselend"; color = "#d4a851"; }
    else if (rate > 0) { label = "variabel";  color = "#b85c4d"; }
    result.set(t.name, { topRate: rate, avgRank, label, color });
  }
  return result;
}

// Score-band: hoe sterk varieert de score van één plaats als de gewichten
// licht wiebelen (±range)? Geeft een eerlijk interval i.p.v. schijnprecisie.
export function scoreBand(town, weights, concelho, { iterations = 48, range = 2 } = {}) {
  const base = computeScore(town, weights, concelho);
  let lo = base, hi = base;
  for (let i = 0; i < iterations; i++) {
    const w = {};
    for (const [k, v] of Object.entries(weights || {})) {
      const d = Math.round((Math.random() * 2 - 1) * range);
      w[k] = Math.max(0, Math.min(10, v + d));
    }
    const p = computeScore(town, w, concelho);
    if (p < lo) lo = p;
    if (p > hi) hi = p;
  }
  return { mid: Math.round(base), lo: Math.round(lo), hi: Math.round(hi), spread: Math.round(hi - lo) };
}
